<template>
  <div>
    <b-card>
      <title-text />
      <line-text1 />
      <line-text2 />
      <line-text3 />
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
} from 'bootstrap-vue'
import TitleText from '@/views/Admin/Footer_contacts/elements/TitleText.vue'
import LineText1 from '@/views/Admin/Footer_contacts/elements/LineText1.vue'
import LineText2 from '@/views/Admin/Footer_contacts/elements/LineText2.vue'
import LineText3 from '@/views/Admin/Footer_contacts/elements/LineText3.vue'

export default {
  name: 'ContactForm',
  components: {
    BCard,
    TitleText,
    LineText1,
    LineText2,
    LineText3,
  },
  data() {
    return {
      options: {
        phone: {
          phone: true,
          phoneRegionCode: 'TR',
        },
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['footerContacts/dataItem']
    },
  },
}
</script>
